import { EXPORT_DATA as FEATURE_PREFIX } from 'featurePrefix.ids'

const EXPORT_DATA_MODAL = 'Export-Data'

export const ExportDataIds = {
  ExportDataButton: `${FEATURE_PREFIX}__${EXPORT_DATA_MODAL}__Export-Button`,
}
